import { createFileRoute } from "@tanstack/react-router";

import { ComingSoon } from "../../../components/stubs/ComingSoon";

export const Route = createFileRoute("/_authed/super/system")({
  component: SuperSystemPage,
  head: () => ({
    meta: [{ title: "System | NBDC" }],
  }),
});

function SuperSystemPage() {
  return <ComingSoon title="System" />;
}
